module.exports = __webpack_public_path__ + "img/gamatron.b355e993.png";